import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FolderListComponent } from './list/list.component';
import { AuthGuard } from '../../auth/auth.guard';
import { FolderService } from './folder.service';
import { SharedModule } from '../../shared/shared.module';
import { FolderCreateComponent } from './create/create.component';
import { FolderFormComponent } from './form/form.component';
import { FolderEditComponent } from './edit/edit.component';

const routes: Routes = [
  { path: 'folders', component: FolderListComponent, canActivate: [AuthGuard] },
  {
    path: 'folders/create',
    component: FolderCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'folders/:id/edit',
    component: FolderEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    FolderListComponent,
    FolderCreateComponent,
    FolderFormComponent,
    FolderEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, FolderService],
})
export class FolderRoutingModule {}
